import { createTheme } from '@mui/material/styles';
import { colors } from './colors';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      dark: colors.primary.dark,
      contrastText: '#fff',
    },
    secondary: {
      main: colors.secondary.main,
      light: colors.secondary.light,
      dark: colors.secondary.dark,
      contrastText: '#fff',
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      fontSize: '22px',
      lineHeight: 1.3,
    },
    h5: { 
      fontWeight: 600,
      fontSize: '20px',
    },
    h6: { 
      fontWeight: 500,
      fontSize: '18px',
    },
    body1: {
      fontSize: '16px',
      lineHeight: 1.5,
    },
    body2: { 
      fontSize: 14,
      lineHeight: 1.4,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: colors.shadows.card,
          border: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
          textTransform: 'none',
          padding: '10px 20px',
          fontSize: '14px',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
          },
        },
        contained: {
          boxShadow: colors.shadows.button,
          '&:hover': {
            boxShadow: colors.shadows.buttonHover,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 16,
            backgroundColor: colors.background.paper,
            boxShadow: colors.shadows.search,
            '&:hover': {
              boxShadow: colors.shadows.searchHover,
            },
            '&.Mui-focused': {
              boxShadow: colors.shadows.searchFocus,
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: colors.shadows.card,
        },
      },
    },
  },
}); 